const uploadTableColorSchema = {
  NEW: "green lighten-4",
  NEW_DAHABSHIIL: "green lighten-3",
  UPDATED_FROM_AUTO: "blue lighten-5",
  UPDATED_FROM_AUTO_DAHABSHIIL: "blue lighten-4",
  UPDATED_FROM_MANUAL: "orange lighten-4",
  UPDATED_FROM_MANUAL_DAHABSHIIL: "yellow lighten-3"
};

// all iso3 codes of active code (list one) from https://en.wikipedia.org/wiki/ISO_4217
const rateCurrencies = [
  "AUD",
  "USD",
  "BDT",
  "XOF",
  "BGN",
  "XAF",
  "CAD",
  "CVE",
  "EUR",
  "DKK",
  "DJF",
  "ERN",
  "ETB",
  "GMD",
  "GHS",
  "GNF",
  "INR",
  "KES",
  "KWD",
  "MGA",
  "MWK",
  "MYR",
  "MAD",
  "MZN",
  "NPR",
  "PKR",
  "PHP",
  "PLN",
  "QAR",
  "RWF",
  "LKR",
  "TZS",
  "TRY",
  "UGX",
  "AED",
  "ZMW",
  "TOP",
  "WST",
  "PGK",
  "BIF",
  "BRL",
  "COP",
  "KZT",
  "UAH",
  "SIT",
  "ALL",
  "IDR",
  "VND",
  "AFN",
  "AMD",
  "ANG",
  "AOA",
  "ARS",
  "AWG",
  "AZN",
  "BAM",
  "BBD",
  "BHD",
  "BMD",
  "BND",
  "BOB",
  "BOV",
  "BSD",
  "BTN",
  "BWP",
  "BYN",
  "BZD",
  "CDF",
  "CHE",
  "CHF",
  "CHW",
  "CLF",
  "CLP",
  "COU",
  "CRC",
  "CUC",
  "CUP",
  "CZK",
  "DOP",
  "DZD",
  "EGP",
  "FJD",
  "FKP",
  "GBP",
  "GEL",
  "GIP",
  "GTQ",
  "GYD",
  "HKD",
  "HNL",
  "HTG",
  "HUF",
  "ILS",
  "IQD",
  "IRR",
  "ISK",
  "JMD",
  "JOD",
  "JPY",
  "KGS",
  "KHR",
  "KMF",
  "KPW",
  "KRW",
  "KYD",
  "LAK",
  "LBP",
  "LRD",
  "LSL",
  "LYD",
  "MDL",
  "MKD",
  "MMK",
  "MNT",
  "MOP",
  "MRU",
  "MUR",
  "MVR",
  "MXN",
  "MXV",
  "NAD",
  "NGN",
  "NIO",
  "NOK",
  "NZD",
  "OMR",
  "PAB",
  "PEN",
  "PYG",
  "RON",
  "RSD",
  "CNY",
  "RUB",
  "SAR",
  "SBD",
  "SCR",
  "SDG",
  "SEK",
  "SGD",
  "SHP",
  "SLE",
  "SLL",
  "SOS",
  "SRD",
  "SSP",
  "STN",
  "SVC",
  "SYP",
  "SZL",
  "THB",
  "TJS",
  "TMT",
  "TND",
  "TTD",
  "TWD",
  "USN",
  "UYI",
  "UYU",
  "UYW",
  "UZS",
  "VED",
  "VES",
  "VUV",
  "XAG",
  "XAU",
  "XBA",
  "XBB",
  "XBC",
  "XBD",
  "XCD",
  "XDR",
  "XPD",
  "XPF",
  "XPT",
  "XSU",
  "XTS",
  "XUA",
  "XXX",
  "YER",
  "ZAR",
  "ZWL",
];

export {
  uploadTableColorSchema,
  rateCurrencies
};
